import * as Dialog from '@radix-ui/react-dialog';
import React from 'react';

export const Trigger = ({ children }: React.PropsWithChildren) => {
  return <Dialog.Trigger asChild>{children}</Dialog.Trigger>;
};

export default Trigger;
